import React, { memo } from 'react'
import PropTypes from 'prop-types'
import SvgIcon from 'Components/SvgIcon'

import { _MapBoxZoomControl } from './styles'


const ZoomControl = ({ handleZoomClick, nearByListingMap, galleryModalStyle }) => (
  <_MapBoxZoomControl
    nearbyListingMap={nearByListingMap}
    galleryModal={galleryModalStyle}
  >
    <div onClick={() => handleZoomClick(true)}>
      <SvgIcon name={'#icon-plus'} width={16} height={16} />
    </div>
    <div onClick={() => handleZoomClick(false)}>
      <SvgIcon name={'#icon-minus'} width={16} height={16} />
    </div>
  </_MapBoxZoomControl>
)
ZoomControl.propTypes = {
  handleZoomClick: PropTypes.func,
  nearByListingMap: PropTypes.bool,
  galleryModalStyle: PropTypes.bool,
}

export default memo(ZoomControl)
